import Immutable, { Record } from 'immutable';
import GraphModel from './graph';
import { DAILY } from './resolution';
import { LAST_SEVEN_DAYS } from './period';
import { ALL } from '../../../models/device-type';
import autoMapper from 'utils/auto-mapper';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

var AnalyticsFields = Record({
  spot_id: null,
  from_day: dayjs().subtract(7, 'd').utc().unix(),
  to_day: dayjs().utc().unix(),
  period: LAST_SEVEN_DAYS,
  device: ALL,
  resolution: DAILY,
  summary: {
    comments: 0,
    page_views: 0,
    replies: 0,
    registrations: 0,
    likes: 0,
    dislikes: 0
  },
  page_views: new GraphModel(),
  comments: new GraphModel(),
  replies: new GraphModel(),
  likes: new GraphModel(),
  dislikes: new GraphModel(),
  registrations: new GraphModel()
});

function parseData(data, period, graphRes = { type: '', resolution: '' }) {
  var mappedData = autoMapper.map(data, {
    spot_id: 'analytics.spot_id',
    resolution: 'analytics.resolution',
    device: 'analytics.device',
    from_day: 'analytics.from_day',
    to_day: 'analytics.to_day',
    'summary.comments': 'analytics.summary.comments',
    'summary.replies': 'analytics.summary.replies',
    'summary.page_views': 'analytics.summary.page_views',
    'summary.registrations': 'analytics.summary.registrations',
    'summary.likes': 'analytics.summary.likes',
    'summary.dislikes': 'analytics.summary.dislikes'
  });
  mappedData.analytics.page_views = {
    points: data.page_views,
    resolution:
      graphRes.type === 'page_views' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'page_views' ? true : false
  };
  mappedData.analytics.comments = {
    points: data.engagement.comments,
    resolution:
      graphRes.type === 'comments' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'comments' ? true : false
  };
  mappedData.analytics.replies = {
    points: data.engagement.replies,
    resolution:
      graphRes.type === 'comments' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'comments' ? true : false
  };
  mappedData.analytics.likes = {
    points: data.ranks.likes,
    resolution: graphRes.type === 'likes' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'likes' ? true : false
  };
  mappedData.analytics.dislikes = {
    points: data.ranks.dislikes,
    resolution: graphRes.type === 'likes' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'likes' ? true : false
  };
  mappedData.analytics.registrations = {
    points: data.registrations,
    resolution:
      graphRes.type === 'registrations' ? graphRes.resolution : mappedData.analytics.resolution,
    period,
    popPoint: graphRes.type === '' || graphRes.type === 'registrations' ? true : false
  };

  mappedData.analytics.period = period;
  return mappedData;
}

class Analytics extends AnalyticsFields {
  parse(data, graphRes = { type: '', resolution: '' }) {
    if (!data) {
      return this;
    }
    data = parseData(data, this.period, graphRes).analytics;

    var fields = {};

    ['spot_id', 'from_day', 'to_day', 'device', 'summary', 'resolution', 'period'].forEach(
      field => (fields[field] = data[field] !== undefined ? data[field] : this.get(field))
    );
    fields.page_views = data.page_views
      ? this.get('page_views').parse(data.page_views)
      : this.get('page_views');
    fields.comments = data.comments
      ? this.get('comments').parse(data.comments)
      : this.get('comments');
    fields.replies = data.replies ? this.get('replies').parse(data.replies) : this.get('replies');
    fields.registrations = data.registrations
      ? this.get('registrations').parse(data.registrations)
      : this.get('registrations');
    fields.likes = data.likes ? this.get('likes').parse(data.likes) : this.get('likes');
    fields.dislikes = data.dislikes
      ? this.get('dislikes').parse(data.dislikes)
      : this.get('dislikes');
    var newAnalytics = new Analytics(fields);
    return Immutable.is(this, newAnalytics) ? this : newAnalytics;
  }

  static getPeriod() {
    return this.period;
  }
}

export default Analytics;
